exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news-list {\n  position: absolute;\n  margin: 30px 0;\n  width: 100%;\n  transition: all .5s cubic-bezier(.55,0,.1,1);\n}\n\n.news-list ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.news-item {\n  background-color: #fff;\n  padding: 20px 30px 20px 80px;\n  border: 1px solid #eee;\n  position: relative;\n  line-height: 20px;\n}\n\n.news-item .meta {\n  font-size: .85em;\n  color: #828282;\n}\n\n.news-item .meta a {\n  color: #828282;\n  text-decoration: underline;\n}\n\n.news-item .meta a:hover {\n  color: #f60;\n}\n\n.news-item .avatar {\n  position: absolute;\n  top: 50%;\n  left: 16px;\n  width: 48px;\n  margin-top: -24px;\n  border-radius: 6px;\n}\n\n@media (max-width:600px) {\n  .news-list {\n    margin: 10px 0;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/topic-list/topic-list.component.css
// module id = 161
// module chunks = 1